export class EffectStats {
    static lapsLeft = Number.MAX_SAFE_INTEGER;
    static startCountdown = 1;
}